jQuery(document).ready(function ($) {
    $('.submit.buy.button').prop('value', 'Place Order');
    $("#eway_credit_card_form label[for='EWAY_CARDCVN']").text("Card CVC Code*");
    $("#EWAY_CARDCVN").prop('placeholder', 'CVC');
    $("#eway_credit_card_form").css('display', 'block');

    $('body').append(`
        <div id="ewayPaymentProcessingModal" class="eway-payment-processing-modal">
            <div class="modal-content">
                <div class="spinner"></div>
                <h2 class="modal-title">Processing Payment</h2>
                <p class="modal-text">Please do not close or refresh this page while your payment is being processed.</p>
            </div>
        </div>
    `);

    $('#eway_credit_card_form').on('submit', function() {
        $('#ewayPaymentProcessingModal').show();
    });
});